// Distinct color per substitution slot (1..10). The same color is shown
// on the row in the Substitution List and on the "sub takes over" badge
// inside each Building Slot — so a scanner can match the two visually.

export const SUB_COLORS = [
  { bg: 'bg-red-500',     ring: 'ring-red-500',     text: 'text-white' },
  { bg: 'bg-orange-500',  ring: 'ring-orange-500',  text: 'text-white' },
  { bg: 'bg-amber-400',   ring: 'ring-amber-400',   text: 'text-slate-900' },
  { bg: 'bg-yellow-300',  ring: 'ring-yellow-300',  text: 'text-slate-900' },
  { bg: 'bg-lime-400',    ring: 'ring-lime-400',    text: 'text-slate-900' },
  { bg: 'bg-emerald-500', ring: 'ring-emerald-500', text: 'text-white' },
  { bg: 'bg-teal-400',    ring: 'ring-teal-400',    text: 'text-slate-900' },
  { bg: 'bg-sky-400',     ring: 'ring-sky-400',     text: 'text-slate-900' },
  { bg: 'bg-indigo-500',  ring: 'ring-indigo-500',  text: 'text-white' },
  { bg: 'bg-fuchsia-500', ring: 'ring-fuchsia-500', text: 'text-white' },
] as const;

export function subColor(pos: number) {
  return SUB_COLORS[(pos - 1) % SUB_COLORS.length];
}
